import React, { useState } from 'react';
import { Sparkles, FileText, Plug, Mic, History, ShieldCheck } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import { cn } from '../../utils/cn';
import SkillRunner from './SkillRunner';
import ContentStudio from './ContentStudio';
import { ConnectionPanel, BrandVoicePanel, HistoryPanel, SkillPermissionsPanel } from './SettingsPanels';

// LinkedIn AI Skill Center. Talks only to /api/linkedin-ai/*; every permission decision is made server-side.
const TABS = [
  { key: 'skills', label: 'AI Skills', icon: Sparkles, el: SkillRunner },
  { key: 'studio', label: 'Content Studio', icon: FileText, el: ContentStudio },
  { key: 'connection', label: 'Connection & Status', icon: Plug, el: ConnectionPanel },
  { key: 'voice', label: 'Brand Voice', icon: Mic, el: BrandVoicePanel },
  { key: 'perms', label: 'Skill Permissions', icon: ShieldCheck, el: SkillPermissionsPanel },
  { key: 'history', label: 'History & Usage', icon: History, el: HistoryPanel },
];

export default function LinkedInAiPage() {
  const [tab, setTab] = useState('skills');
  const Active = TABS.find((t) => t.key === tab).el;
  return (
    <div className="p-6 lg:p-8 space-y-6">
      <PageHeader title="LinkedIn AI Skill Center" subtitle="Draft, review and plan LinkedIn content with your own AI provider. Nothing is posted or sent without your explicit approval." icon={Sparkles} />
      <div role="tablist" className="flex items-center border-b border-[#E5E5E5] gap-6 overflow-x-auto">
        {TABS.map((t) => (
          <button key={t.key} role="tab" aria-selected={tab === t.key} onClick={() => setTab(t.key)}
            className={cn('flex items-center gap-2 pb-3 text-[13px] font-semibold border-b-2 whitespace-nowrap', tab === t.key ? 'border-[#0176D3] text-[#0176D3]' : 'border-transparent text-[#5C5C5C] hover:text-[#2E2E2E]')}>
            <t.icon size={15} />{t.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
